import type { ListaItens, SeletorItem } from '@Lar21/imaginii-web-components/vue'
import type { FiltrosCatalogoMotivoPadrao, OpcaoMotivoPadrao, SelecaoCatalogoMotivoPadrao } from '../catalogo-motivo-padrao.tipos'
export const CHAVE_I18N_CATALOGO_MOTIVO_PADRAO = 'srcNext.estruturaDePontoDaEmpresa.catalogoMotivoPadrao'
export const filtrarOpcoesMotivoPadrao = (
  opcoes: readonly OpcaoMotivoPadrao[],
  filtros?: FiltrosCatalogoMotivoPadrao,
): readonly OpcaoMotivoPadrao[] => {
  if (!filtros || Object.keys(filtros).length === 0) return opcoes

  const resultado: OpcaoMotivoPadrao[] = []
  for (const opcao of opcoes) {
    const possuiEstado = filtros.active === undefined
      || opcao.active === filtros.active
    const possuiTipo = filtros.kind === undefined
      || (typeof opcao.kind === 'string' && filtros.kind.includes(opcao.kind))
    if (possuiEstado && possuiTipo) resultado.push(opcao)
  }
  return resultado
}
const item = (opcao: OpcaoMotivoPadrao): SeletorItem => ({
  chave: opcao.id, valor: opcao.description,
  ...(typeof opcao.code === 'string' && opcao.code.trim() ? { legenda: opcao.code } : {}),
})
const listaSelecionada = (
  valor: SelecaoCatalogoMotivoPadrao,
  multipla: boolean,
): readonly OpcaoMotivoPadrao[] => {
  if (valor === null) return []
  if (!Array.isArray(valor)) return [valor as OpcaoMotivoPadrao]
  if (multipla) return valor as readonly OpcaoMotivoPadrao[]
  const primeira = valor[0] as OpcaoMotivoPadrao | undefined
  return primeira ? [primeira] : []
}
export const criarEstadoSeletorCatalogoMotivoPadrao = (
  opcoes: readonly OpcaoMotivoPadrao[],
  valor: SelecaoCatalogoMotivoPadrao,
  multipla: boolean,
): ListaItens => {
  const carregados = opcoes.filter(opcao => typeof opcao.id === 'string' && opcao.id.trim() && typeof opcao.description === 'string' && opcao.description.trim()).map(item)
  const porId = new Map(carregados.map((i) => [String(i.chave), i]))
  return {
    carregados,
    selecionados: listaSelecionada(valor, multipla).flatMap((opcao) => {
      const selecionado = porId.get(opcao.id)
      return selecionado ? [selecionado] : []
    }),
  }
}
export const extrairValorDoSeletorCatalogoMotivoPadrao = (
  estado: ListaItens,
  opcoes: readonly OpcaoMotivoPadrao[],
  multipla: boolean,
): SelecaoCatalogoMotivoPadrao => {
  const porId = new Map(opcoes.map((opcao) => [opcao.id, opcao]))
  const resultado = [...new Set(estado.selecionados.map(({ chave }) => String(chave)))]
    .flatMap((id) => {
      const opcao = porId.get(id)
      return opcao ? [opcao] : []
    })
  return multipla ? resultado : (resultado[0] ?? null)
}
type Traduzir = (chave: string) => string
export const criarPropriedadesPontotelSeletorMotivoPadrao = ({
  traduzir, label, placeholder, erro,
}: Readonly<{ traduzir: Traduzir, label?: string, placeholder?: string, erro: string | null }>) => ({
  tamanho: 'M' as const, largura: '100%', tamanhoPagina: 20,
  pesquisavel: true, recarregarTodos: true,
  label: label ?? traduzir(`${CHAVE_I18N_CATALOGO_MOTIVO_PADRAO}.label`),
  placeholder: placeholder ?? traduzir(`${CHAVE_I18N_CATALOGO_MOTIVO_PADRAO}.placeholder`),
  erro,
  traducaoNenhumResultado: traduzir(`${CHAVE_I18N_CATALOGO_MOTIVO_PADRAO}.nenhumResultado`),
  traducaoSelecionado: traduzir(`${CHAVE_I18N_CATALOGO_MOTIVO_PADRAO}.selecionado`),
  traducaoSelecionadosPlural: traduzir(`${CHAVE_I18N_CATALOGO_MOTIVO_PADRAO}.selecionados`),
  traducaoRecarregarTodos: traduzir(`${CHAVE_I18N_CATALOGO_MOTIVO_PADRAO}.recarregar`),
  traducaoRecarregado: traduzir(`${CHAVE_I18N_CATALOGO_MOTIVO_PADRAO}.recarregado`),
})
